<template>
    <div>
        <div style="margin-top:50px;margin-bottom:20px;margin-left:50px;margin-right:50px;">
            <div style="float:left;text-align:left;">
                <span style="color:#606266;">痛点导航</span>
                <el-cascader
                    v-model="search_painspot_type"
                    :options="painspot_navigation"
                    placeholder="请选择痛点类型"
                    style="margin-left:10px;width:250px;"
                    clearable
                    @change="queryPainSpot">
                </el-cascader>
                <span style="margin-left:20px;color:#606266;">痛点名称</span>
                <el-input v-model="search_painspot_title" placeholder="请输入痛点名称" style="margin-left:10px;width:250px;" clearable @keyup.native.enter="queryPainSpot"></el-input>
            </div>
            <div style="text-align:right;">
                <el-button type="primary" icon="el-icon-search" size="mini" @click="queryPainSpot">查询</el-button>
                <el-button size="mini" icon="el-icon-refresh" style="margin-left:10px;" @click="reset">重置</el-button>
            </div>
        </div>
        <div style="border-top:1px solid #ebeef5;margin-left:50px;margin-right:50px;"></div>
        <div style="margin-left:50px;margin-right:50px;margin-top:30px;">
            <div style="float:left;text-align:left;">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="add_pain_spot">新建痛点</el-button>
                <el-button type="danger" icon="el-icon-sold-out" size="mini" style="margin-left:10px;" @click="multiOperation('remove')">下架</el-button>
                <el-button type="success" icon="el-icon-sell" size="mini" style="margin-left:10px;" @click="multiOperation('recover')">上架</el-button>
                <el-button type="warning" icon="el-icon-setting" size="mini" style="margin-left:10px;" @click="adjust_structure">调整目录</el-button>
            </div>
            <div style="text-align:right;">
                <el-checkbox v-model="is_show_backup" @change="queryPainSpot">展示已归档痛点</el-checkbox>
                <el-button type="primary" icon="el-icon-edit-outline" size="mini" style="margin-left:10px;" @click="multiOperation('edit')" disabled>批量编辑</el-button>
                <el-button icon="el-icon-upload2" size="mini" disabled>导入</el-button>
                <el-button icon="el-icon-download" size="mini" disabled>导出</el-button>
            </div>
        </div>
        <div style="margin-left:50px;margin-right:50px;margin-top:10px;">
            <el-table
            :data="painspots_info"
            style="width:100%"
            stripe
            border
            @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column type="index"></el-table-column>
                <!-- <el-table-column lable="序号" type="index" width="5%">
                    <template slot-scope="scope">
                        {{ scope.$index+1 }}
                    </template>
                </el-table-column> -->
                <el-table-column prop="title" label="痛点名称" min-width="18%"></el-table-column>
                <el-table-column prop="classification" label="一级目录" min-width="8%"></el-table-column>
                <el-table-column prop="sub_class" label="二级目录" min-width="8%"></el-table-column>
                <el-table-column prop="update_time" label="更新时间" min-width="8%"></el-table-column>
                <el-table-column prop="status" label="状态" min-width="6%"></el-table-column>
                <el-table-column prop="permit_count" label="分配数" min-width="6%"></el-table-column>
                <!-- <el-table-column prop="answer_count" label="回答数" min-width="6%">
                    <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="font-weight:bold;"
                        @click="show_details(scope.row.id, 'answer_count')">{{ scope.row.answer_count }}</el-button>
                    </template>
                </el-table-column> -->
                <el-table-column prop="favorite_count" label="收藏数" min-width="6%">
                    <!-- <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="font-weight:bold;"
                        @click="show_details(scope.row.id, 'favorite_count')">{{ scope.row.favorite_count }}</el-button>
                    </template> -->
                </el-table-column>
                <el-table-column prop="rating" label="评分" min-width="6%">
                </el-table-column>
                <el-table-column prop="operations" label="操作" min-width="7%">
                    <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="font-weight:bold;"
                        @click="handleView(scope.row)">详情</el-button>
                        <el-button
                        type="text"
                        style="color:#F56C6C;font-weight:bold;"
                        @click="handleDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top:10px;" v-if="painspots_info.length > 0">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageinfo.current"
                    :page-sizes="pageinfo.page_sizes"
                    :page-size="pageinfo.page_size"
                    layout="total, sizes, prev, pager, next"
                    :total="pageinfo.count">
                </el-pagination>
            </div>
            <el-dialog
            :visible.sync="dialogVisible"
            :fullscreen="true"
            :show-close="false"
            custom-class="fullscreen-dialog"
            @open="handleDialogOpen" 
            @opened="handleDialogOpened" 
            @close="handleDialogClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false">
            <template #title>
                <div class="dialog-header">
                <span>{{ dialog_title }}</span>
                <el-button
                    class="close-btn"
                    icon="el-icon-close"
                    @click="dialogVisible = false"
                ></el-button>
                </div>
            </template>

            <!-- 弹窗内容 -->
            <div class="dialog-content" v-if="dialog_show_type=='painspot_edit'">
                <div style="text-align:left;margin-left:15px;margin-bottom:20px;">
                    <el-button size="mini" icon="el-icon-document-checked" type="primary" @click="saveRichText" v-show="isEdit">保存</el-button>
                    <el-button size="mini" icon="el-icon-edit" type="primary" @click="editRichText" v-show="!isEdit">编辑</el-button>
                    <span style="margin-left:30px;">痛点名称</span>
                    <el-input v-model="painspot_title_mod" placeholder="请输入痛点名称" style="margin-left:10px;width:250px;" clearable :disabled="!isEdit"></el-input>
                    <span style="color:#E6A23C;margin-left:20px;">说明：修改痛点后，原痛点会增加一条"已归档"状态的记录</span>
                </div>
                <div class="editor-container" v-show="isEdit">
                    <quill-editor
                    v-model="content"
                    ref="myQuillEditor"
                    :options="editorOptions"
                    />
                </div>
                <div class="ql-editor" v-html="content" v-show="!isEdit"></div>
            </div>
            <div class="dialog-content" v-else-if="dialog_show_type=='painspot_create'">
                <div style="text-align:left;margin-left:15px;margin-bottom:20px;">
                    <span>选择所属痛点目录</span>
                    <el-cascader
                        v-model="belong_painspot_type"
                        :options="painspot_navigation"
                        placeholder="选择痛点目录"
                        style="margin-left:10px;width:300px;"
                        clearable>
                    </el-cascader>
                    <span style="margin-left:20px;">配置痛点名称</span>
                    <el-input v-model="painspot_title_add" placeholder="请输入痛点名称" style="margin-left:10px;width:250px;" clearable></el-input>
                    <el-button size="mini" icon="el-icon-document-checked" type="primary" style="margin-left:10px;" @click="createRichText">提交</el-button>
                </div>
                <div class="create-container">
                    <quill-editor
                    v-model="content_add"
                    ref="myQuillEditor"
                    :options="editorOptions"
                    />
                </div>
            </div>
            <div class="dialog-content" v-else>
                <!-- 这里放你的具体内容 -->
                <div style="margin-left:50px;margin-right:50px;margin-top:10px;">
                    <el-table
                    :data="details_info"
                    style="width:100%"
                    stripe
                    border
                    v-if="dialog_show_content=='count_details'">
                        <el-table-column type="index"></el-table-column>
                        <el-table-column :key="index" v-for="(col, index) in details_columns" :prop="col.name" :label="col.label" :min-width="col.min_width"></el-table-column>
                    </el-table>
                    <div v-else>
                        <div class="action-buttons">
                            <el-button size="small" type="primary" icon="el-icon-plus" @click="addRootNode">添加一级目录</el-button>
                            <el-button size="small" type="primary" icon="el-icon-check" @click="saveTreeNodes">保存</el-button>
                            <span style="color:#F56C6C;margin-left:20px;padding-top:5px;"><i class="el-icon-warning"/><span style="margin-left:5px;">痛点新建时支持重命名，新建完成后不支持重命名！</span></span>
                        </div>
                        <div class="tree-container">
                            <!-- <div style="text-align:left;">
                                <el-button size="mini" icon="el-icon-plus" type="primary" @click="addRootNode">添加根节点</el-button>
                            </div>
                            <el-tree
                            :data="painspot_navigation_adjust"
                            show-checkbox
                            node-key="id"
                            default-expand-all
                            :expand-on-click-node="false"
                            style="margin-top:15px;">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span>{{ node.label }}</span>
                                <span>
                                <el-button
                                    type="text"
                                    size="mini"
                                    @click="() => append(node, data)">
                                    增加节点
                                </el-button>
                                <el-button
                                    type="text"
                                    size="mini"
                                    @click="() => remove(node, data)">
                                    删除节点
                                </el-button>
                                </span>
                            </span>
                            </el-tree> -->
                            <el-tree
                            v-if="painspot_navigation_adjust.length > 0"
                            :data="painspot_navigation_adjust"
                            node-key="id"
                            default-expand-all
                            :props="defaultProps"
                            :allow-drop="allowDrop"
                            draggable
                            :highlight-current="true"
                            ref="tree"
                            >
                            <span slot-scope="{ node, data }" class="custom-tree-node" :class="{ 'highlight': data.id === highlightedNode }">
                                <!-- 编辑状态 -->
                                <template v-if="data.id === editingNodeId">
                                <el-input 
                                    v-model="editingNodeLabel" 
                                    size="small" 
                                    class="editing-input"
                                    autofocus
                                    @keyup.enter.native="saveEdit(node, data)"
                                    @keyup.esc.native="cancelEdit(data)"
                                ></el-input>
                                <el-button size="small" type="success" @click="saveEdit(node, data)">保存</el-button>
                                <el-button size="small" @click="cancelEdit(data)">取消</el-button>
                                </template>
                                
                                <!-- 正常状态 -->
                                <template v-else>
                                <div class="node-content">
                                    <span class="level-indicator" :class="'level-' + node.level">{{ node.level }}</span>
                                    <i :class="getNodeIcon(node.level)" :style="{color: getNodeColor(node.level)}"></i>
                                    <span>{{ node.label }}</span>
                                </div>
                                
                                <div class="node-actions">
                                    <!-- <div class="move-buttons">
                                    <el-button 
                                        type="text" 
                                        size="mini" 
                                        icon="el-icon-top" 
                                        :disabled="isFirstNode(node)"
                                        @click="() => moveNode(node, data, 'up')"
                                        title="上移"
                                    ></el-button>
                                    <el-button 
                                        type="text" 
                                        size="mini" 
                                        icon="el-icon-bottom" 
                                        :disabled="isLastNode(node)"
                                        @click="() => moveNode(node, data, 'down')"
                                        title="下移"
                                    ></el-button>
                                    </div> -->
                                    
                                    <el-button 
                                    v-if="node.level < 2" 
                                    type="text" 
                                    size="mini" 
                                    icon="el-icon-plus" 
                                    @click="() => appendNode(node, data)"
                                    title="添加子节点"
                                    ></el-button>
                                    
                                    <el-button
                                    v-if="node.level < 3" 
                                    type="text" 
                                    size="mini" 
                                    icon="el-icon-edit" 
                                    @click="() => startEdit(data)"
                                    title="编辑名称"
                                    ></el-button>
                                    
                                    <el-button 
                                    v-if="node.level < 3"
                                    type="text" 
                                    size="mini" 
                                    icon="el-icon-delete" 
                                    @click="() => removeNode(node, data)"
                                    :disabled="isLastRootNode(node)"
                                    title="删除节点"
                                    ></el-button>
                                </div>
                                </template>
                            </span>
                            </el-tree>
                            
                            <!-- 空状态 -->
                            <div v-else class="empty-state">
                            <i class="el-icon-folder-opened"></i>
                            <h3>暂无目录数据</h3>
                            <p>请添加根节点开始创建目录结构</p>
                            <el-button type="primary" icon="el-icon-plus" @click="addRootNode">添加根节点</el-button>
                            </div>
                        
                            <!-- <div class="action-buttons">
                            <el-button type="primary" icon="el-icon-plus" @click="addRootNode">添加根节点</el-button>
                            <el-button type="warning" icon="el-icon-sort" @click="expandAll">{{ isExpanded ? '收起所有' : '展开所有' }}</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="resetTree" :disabled="painspot_navigation_adjust.length === 0">重置树结构</el-button>
                            <el-button type="success" icon="el-icon-download" @click="exportTreeData">导出数据</el-button>
                            </div> -->
                            
                            <!-- <div class="operation-tips">
                                <h3><i class="el-icon-info"></i> 操作说明</h3>
                                <ul>
                                    <li><strong>层级限制</strong>：目录结构最多两层（根节点和子节点）</li>
                                    <li><strong>添加节点</strong>：点击根节点旁的"+"图标添加子节点，使用顶部按钮添加根节点</li>
                                    <li><strong>编辑节点</strong>：点击节点旁的编辑图标修改节点名称</li>
                                    <li><strong>删除节点</strong>：点击删除图标删除节点（至少保留一个根节点）</li>
                                    <li><strong>移动节点</strong>：使用 <i class="el-icon-top"></i> 和 <i class="el-icon-bottom"></i> 按钮上下移动节点位置</li>
                                    <li><strong>拖拽排序</strong>：可通过拖拽节点调整位置（但子节点不能拖拽为根节点）</li>
                                </ul>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
let id = 100000;
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";

export default {
    components: { quillEditor },
    created() {
        this.getPainSpotNavigation();
        this.getPainSpotContens('full');
    },
    data() {
        // const painspot_navigation_adjust = [
        //         {id: 1, label: 'painspotA', children: [{id: 4, label: 'painspotA_1', children: [{id: 5, label: 'painspotA_1_1'}, {id: 6, label: 'painspotA_1_2'}, {id: 7, label: 'painspotA_1_3'}]}, {id: 8, label: 'painspotA_2', children: [{id: 9, label: 'painspotA_2_1'}, {id: 10, label: 'painspotA_2_2'}, {id: 11, label: 'painspotA_2_3'}]}, {id: 12, label: 'painspotA_3', children: [{id: 13, label: 'painspotA_3_1'}, {id: 14, label: 'painspotA_3_2'}, {id: 15, label: 'painspotA_3_3'}]}]},
        //         {id: 2, label: 'painspotB', children: [{id: 16, label: 'painspotB_1', children: [{id: 17, label: 'painspotB_1_1'}, {id: 18, label: 'painspotB_1_2'}, {id: 19, label: 'painspotB_1_3'}]}, {id: 20, label: 'painspotB_2', children: [{id: 21, label: 'painspotB_2_1'}, {id: 22, label: 'painspotB_2_2'}, {id: 23, label: 'painspotB_2_3'}]}, {id: 24, label: 'painspotB_3', children: [{id: 25, label: 'painspotB_3_1'}, {id: 26, label: 'painspotB_3_2'}, {id: 27, label: 'painspotB_3_3'}]}]},
        //         {id: 3, label: 'painspotC', children: [{id: 28, label: 'painspotC_1', children: [{id: 29, label: 'painspotC_1_1'}, {id: 30, label: 'painspotC_1_2'}, {id: 31, label: 'painspotC_1_3'}]}, {id: 32, label: 'painspotC_2', children: [{id: 33, label: 'painspotC_2_1'}, {id: 34, label: 'painspotC_2_2'}, {id: 35, label: 'painspotC_2_3'}]}, {id: 36, label: 'painspotC_3', children: [{id: 37, label: 'painspotC_3_1'}, {id: 38, label: 'painspotC_3_2'}, {id: 39, label: 'painspotC_3_3'}]}]}];
        return {
            dialog_title: '',
            dialogVisible: false,
            search_painspot_type: [],
            belong_painspot_type: [],
            search_painspot_title: '',
            painspot_title_add: '',
            painspot_title_mod: '',
            // belong_painspot_navigation: [],
            painspot_navigation: [],
            // painspot_navigation_adjust: JSON.parse(JSON.stringify(painspot_navigation_adjust)),
            painspot_navigation_adjust: [],
            painspots_info: [],
            details_info: [],
            details_columns: [],
            selectedRows: [],
            dialog_show_type: 'painspot_edit',
            dialog_show_content: 'count_details',
            content: '',
            content_add: '',
            isEdit: false,
            editorOptions: {
                modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'direction': 'rtl' }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['link'],
                    ['clean']
                ]
                },
                placeholder: '请输入内容...',
                theme: 'snow',
            },
            editor: null,
            toolbar: null,
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 20,
                page_sizes: [1, 10, 20, 50, 100],
            },
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            editingNodeId: null,
            editingNodeLabel: '',
            originalNodeLabel: '',
            isExpanded: true,
            highlightedNode: null,
            highlightTimer: null,
            current_pid: null,
            is_show_backup: false,
        }
    },
    methods: {
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            this.queryPainSpot();
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            this.queryPainSpot();
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleDelete(id) {
            this.$confirm("确认删除该痛点么？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params;
                params = {
                    'pid': id,
                }           
                getdata.getListP("deleteGLYFPainSpot", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: resp.data.message,
                            type: 'success',
                        }) 
                        this.queryPainSpot();             
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: 'error',
                            duration: 6000,
                        })
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }).catch(() => {
                
            })
        },
        reset() {
            this.search_painspot_type = [];
            this.search_painspot_title = '';
            this.queryPainSpot();
        },
        getPainSpotNavigation() {
            getdata.getList("getPainSpotNavigation")
            .then(resp => {
                if(resp.data.code == 200){
                    this.painspot_navigation = resp.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getTreeNodes() {
            getdata.getList("getTreeNodes")
            .then(resp => {
                if(resp.data.code == 200){
                    // this.belong_painspot_navigation = resp.data.nav_data;
                    this.painspot_navigation_adjust = resp.data.data;
                    this.painspot_navigation_adjust = JSON.parse(JSON.stringify(this.painspot_navigation_adjust));
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        saveTreeNodes() {
            postdata.postList("saveTreeNodes", JSON.stringify({tree: this.painspot_navigation_adjust}))
                .then(resp => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: resp.data.message,
                            type: "success",
                        })
                        this.getPainSpotNavigation();
                        this.dialogVisible = false;
                        this.queryPainSpot();                   
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: "error",
                            duration: 4000,
                        })
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        },
        handleView(row) {
            this.isEdit = false;
            this.content = '';
            this.current_pid = row.id;
            this.painspot_title_mod = row.title;
            this.getPainSpotContens('details', row.id, 'empty', 'empty', 'empty');
            this.dialog_show_type = 'painspot_edit';
            this.dialog_title = '痛点详情';
            this.dialogVisible = true;
        },
        queryPainSpot() {
            if(this.search_painspot_type.length>0){
                this.getPainSpotContens('query', 'empty', this.search_painspot_type[0], this.search_painspot_type[1], this.search_painspot_title);
            }else{
                this.getPainSpotContens('query', 'empty', 'empty', 'empty', this.search_painspot_title);
            }
        },
        getPainSpotContens(type, pid, classification, sub_class, title) {
            classification = classification||'empty';      // 设置参数默认值为-1
            sub_class = sub_class||'empty';
            title = title||'empty';
            pid = pid||'empty';
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                classification: classification,
                sub_class: sub_class,
                title: title,
                pid: pid,
                type: type,
                is_show_backup: this.is_show_backup,
            }
            
            getdata.getListP("getPainSpotContens", params)
            .then(resp => {
                if(resp.data.code == 200){
                    if(type==='full' || type==='query'){
                        this.painspots_info = resp.data.data;
                        this.pageinfo.count = resp.data.count;
                    }else if(type==='details'){
                        this.content = resp.data.data[0].content;
                    }                   
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        add_pain_spot() {
            this.dialog_show_type = 'painspot_create';
            this.dialog_title = '新增痛点';
            this.dialogVisible = true;
        },
        show_details(uid, show_type) {
            this.dialog_show_type = 'count_details';
            this.dialog_show_content = 'count_details';
            if(show_type=='answer_count'){
                this.dialog_title = '回答明细';
                this.details_columns = [
                    {'name': 'datetime', 'label': '回答日期', 'min_width': '25%'}, 
                    {'name': 'title', 'label': '回答问题', 'min_width': '50%'}, 
                    {'name': 'status', 'label': '状态', 'min_width': '25%'}]
            }else if(show_type=='favorite_count'){
                this.dialog_title = '收藏明细';
                this.details_columns = [
                    {'name': 'datetime', 'label': '收藏日期', 'min_width': '40%'}, 
                    {'name': 'title', 'label': '收藏问题', 'min_width': '60%'}]
            }
            this.dialogVisible = true;
        },
        adjust_structure() {
            this.dialog_show_type = 'adjust_structure';
            this.dialog_show_content = 'adjust_structure';
            this.dialog_title = '调整痛点导航';
            // 预留，后台获取痛点导航目录结构
            this.dialogVisible = true;
        },
        handleEdit(uid) {
            this.dialog_show_type = 'painspot_edit';
            this.dialog_title = '痛点详情';
            // 预留，获取痛点内容
            this.dialogVisible = true;
        },
        handleSelectionChange(val) {
            this.selectedRows = val;
            console.log(val);
        },
        multiOperation(type) {
            if(this.selectedRows.length==0){
                this.$message({
                message: '未选择痛点！',
                type: 'error',
                duration: 2000,
                })
                return;
            }else{
                var selectedIds = [];
                var row;
                for(row in this.selectedRows){
                    selectedIds.push(this.selectedRows[row]['id']);
                }
                let params;
                params = {
                    'selectedIds': selectedIds,
                }
                if(type=='remove') { 
                    getdata.getListP("removePainSpots", params)
                    .then(resp => {
                        if(resp.data.code == 200){
                            this.$message({
                                message: resp.data.message,
                                type: "success",
                            })
                            this.queryPainSpot();
                        }else{
                            this.$message({
                                message: resp.data.message,
                                type: "error",
                                duration: 4000,
                            })
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
                }else if(type=='recover') {
                    getdata.getListP("recoverPainSpots", params)
                    .then(resp => {
                        if(resp.data.code == 200){
                            this.$message({
                                message: resp.data.message,
                                type: "success",
                            })
                            this.queryPainSpot();
                        }else{
                            this.$message({
                                message: resp.data.message,
                                type: "error",
                                duration: 4000,
                            })
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
                }else if(type=='edit') {
                    console.log(selectedIds);
                }
            }
        },
        append(node, data) {
            if (node.level === 3) {
                this.$message({
                    message: '仅支持三级目录！',
                    type: "error",
                    duration: 4000,
                })
                return;
            }
            const newId = Math.max(...this.getAllNodeIds(), 0) + 1;
            const newChild = { id: newId, label: '新节点', children: [] };
            if (!data.children) {
            this.$set(data, 'children', []);
            }
            data.children.push(newChild);
        },
        remove(node, data) {
            if (this.isLastRootNode(node)) {
                this.$message({
                    message: '根节点无法删除！',
                    type: "error",
                    duration: 4000,
                })
                return;
            }
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex(d => d.id === data.id);
            children.splice(index, 1);
        },
        isLastRootNode1(node) {
            // 只有根节点才需要检查
            if (node.level !== 1) return false;
            
            // 检查是否只剩一个根节点
            return this.painspot_navigation_adjust.length === 1;
        },
        addRootNode1() {
            this.painspot_navigation_adjust.push({ id: id++, label: "新一级节点" });
        },
        editRichText() {
            this.isEdit = true;
        },
        saveRichText() {
            postdata.postList("submitPainSpotContentMod", JSON.stringify({'id': this.current_pid, 'mod_content': this.content, 'mod_title': this.painspot_title_mod}))
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: resp.data.message,
                    type: 'success',
                    }) 
                    this.isEdit = false; 
                    this.queryPainSpot();     
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        createRichText() {
            if(!this.content_add){
                this.$message({
                    message: '痛点内容为空，请配置！',
                    type: "error",
                    duration: 4000,
                })
                return;
            }else if(!this.painspot_title_add) {
                this.$message({
                    message: '痛点名称为空，请配置！',
                    type: "error",
                    duration: 4000,
                })
                return;
            }else if(this.belong_painspot_type.length!=2) {
                this.$message({
                    message: '所属痛点目录配置错误，必须选择到二级目录！',
                    type: "error",
                    duration: 4000,
                })
                return;
            }else{
                postdata.postList("addPainSpotContent", JSON.stringify({classification: this.belong_painspot_type[0], sub_class: this.belong_painspot_type[1], title: this.painspot_title_add, content: this.content_add}))
                .then(resp => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: resp.data.message,
                            type: "success",
                        })
                        this.dialogVisible = false;
                        // this.belong_painspot_type = '';
                        // this.belong_painspot_navigation = [];
                        // this.content_add = '';
                        this.queryPainSpot();
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: "error",
                            duration: 4000,
                        })
                    }
                })
                .catch(err => {
                    console.log(err);
                })
            }
        },
        // 图片上传处理
        imageHandler() {
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.click()
            
            input.onchange = async () => {
                const file = input.files[0]
                const formData = new FormData()
                formData.append('image', file)

                // 调用后端上传接口
                const { data } = await postdata.uploadFiles('uploadImages', formData)
                const quill = this.$refs.myQuillEditor.quill
                const range = quill.getSelection()
                quill.insertEmbed(range.index, 'image', data.url)
            }
            },
            // 新增粘贴图片处理方法
            async handlePasteImage(event) {
            const items = (event.clipboardData || event.originalEvent.clipboardData).items;
            let blob = null;

            for (const item of items) {
                if (item.type.indexOf('image') === 0) {
                blob = item.getAsFile();
                break;
                }
            }

            if (blob) {
                event.preventDefault();
                const formData = new FormData();
                formData.append('image', blob);
                
                try {
                const { data } = await postdata.uploadFiles('uploadImages', formData, {
                    headers: {
                    'Content-Type': 'multipart/form-data'
                    }
                });
                
                const quill = this.$refs.myQuillEditor.quill;
                const range = quill.getSelection();
                quill.insertEmbed(range.index, 'image', data.url);
                } catch (error) {
                console.error('图片上传失败:', error);
                }
            }
        },
        handleDialogOpen() {
            if(this.dialog_show_type=='adjust_structure'){
                this.painspot_navigation_adjust = [];
                this.getTreeNodes();
            }else if(this.dialog_show_type=='painspot_create'){
                this.belong_painspot_type = [];
                // this.belong_painspot_navigation = [];
                this.painspot_title_add = '';
                this.content_add = '';
                this.getPainSpotNavigation();
                // this.getTreeNodes();
            }          
        },
        handleDialogOpened() {
            if(this.dialog_show_type=='painspot_edit'){
                this.$nextTick(() => {
                    // 新增粘贴事件监听
                    const quill = this.$refs.myQuillEditor.quill;
                    this.editor = quill.root;
                    this.toolbar = quill.getModule('toolbar');
                    this.editor.removeEventListener('paste', this.handlePasteImage);
                    this.editor.addEventListener('paste', this.handlePasteImage);
                    // 上传文件的监听
                    this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imageHandler);
                })
            }          
        },
        handleDialogClose() {
            if(this.dialog_show_type=='painspot_edit'){
                // 销毁时移除监听
                if (this.editor) {
                    this.editor.removeEventListener('paste', this.handlePasteImage);
                }
                this.editor = null;
                this.toolbar = null;
            }
        },

        // 获取节点图标
        getNodeIcon(level) {
          switch(level) {
            case 1: return 'el-icon-folder';
            case 2: return 'el-icon-folder-opened';
            case 3: return 'el-icon-document';
            default: return 'el-icon-question';
          }
        },
        // 获取节点颜色
        getNodeColor(level) {
          switch(level) {
            case 1: return '#409EFF';
            case 2: return '#67C23A';
            case 3: return '#E6A23C';
            default: return '#909399';
          }
        },
        // 添加根节点
        addRootNode() {
        //   const newId = Math.max(...this.painspot_navigation_adjust.map(n => n.id), 0) + 1;
          const newId = Math.max(...this.getAllNodeIds(), 0) + 1;
          const newNode = {
            id: newId,
            label: `新一级节点 ${newId}`,
            children: []
          };
          
          this.painspot_navigation_adjust.push(newNode);
          this.highlightNode(newId);
        },
        
        // 添加子节点
        appendNode(node, data) {
          // 第三层节点不能添加子节点
          if (node.level === 3) {
            this.$message.warning("三级节点不允许添加子节点！");
            return;
          }
          
          this.$refs.tree.store.nodesMap[data.id].expanded = false;
          const newId = Math.max(...this.getAllNodeIds(), 0) + 1;
          const newChild = { 
            id: newId, 
            label: node.level === 1 ? `新二级节点 ${newId}` : `新三级节点 ${newId}`,
            children: []
          };
          
          if (!data.children) {
            this.$set(data, 'children', []);
          }

          data.children.push(newChild);
          this.highlightNode(newChild.id);
        //   this.$nextTick(() => {
            // this.painspot_navigation_adjust = [...this.painspot_navigation_adjust];
            
            // this.$refs.tree.store.nodesMap[data.id].expanded = true;
            // this.painspot_navigation_adjust = JSON.parse(JSON.stringify(this.painspot_navigation_adjust));
        //   });
        },
        
        // 删除节点
        removeNode(node, data) {
          // 至少保留一个根节点
          if (this.isLastRootNode(node)) {
            this.$message.warning("必须至少保留一个根节点！");
            return;
          }
          // 存在第三层节点时，上层节点不允许删除
        //   if (node.level < 3) {
        //     if (this.hasGrandchildren(data)) {
        //     this.$message.warning("当前目录下存在痛点，不允许删除！");
        //     return;
        //     }
        //   }
          if (node.level === 2) {
            if (data.children && data.children.length > 0) {
                this.$message.warning("当前目录下存在痛点，不允许删除！");
                return;
            }
          }else if (node.level === 1) {
            // 检查第一层节点：看它的子节点（第二层）中是否有节点拥有子节点（第三层）
            if (data.children && data.children.some(child => child.children && child.children.length > 0)) {
                this.$message.warning("当前目录下存在痛点，不允许删除！");
                return;
            }
          }
          
          this.$confirm(`确定要删除节点 "${data.label}" 吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex(d => d.id === data.id);
            
            if (index !== -1) {
              children.splice(index, 1);
              this.painspot_navigation_adjust = [...this.painspot_navigation_adjust];
              this.$message.success('节点删除成功');
            }
          }).catch(() => {});
        },

        // 检查是否有三层节点
        hasGrandchildren(node) {
            if (node.children) {
                // 对于第一层节点，检查子节点是否有子节点（即孙节点）
                return node.children.some(child => 
                child.children && child.children.length > 0
                );
            }
            return false;
        },
        
        // 开始编辑节点
        startEdit(data) {
          this.editingNodeId = data.id;
          this.editingNodeLabel = data.label;
          this.originalNodeLabel = data.label;
        },
        
        // 保存编辑
        saveEdit(node, data) {
          if (!this.editingNodeLabel.trim()) {
            this.$message.warning('节点名称不能为空');
            return;
          }
          
          data.label = this.editingNodeLabel;
          this.editingNodeId = null;
          this.editingNodeLabel = '';
          this.originalNodeLabel = '';
          this.$message.success('节点名称已更新');
          this.highlightNode(data.id);
        },
        
        // 取消编辑
        cancelEdit(data) {
          data.label = this.originalNodeLabel;
          this.editingNodeId = null;
          this.editingNodeLabel = '';
          this.originalNodeLabel = '';
        },
        
        // 拖拽时检查
        allowDrop(draggingNode, dropNode, type) {
          // 禁止嵌套到第四层
          if (type === 'inner' && dropNode.level === 3) {
            return false;
          }
          
          // 禁止将孙节点（第三层）拖拽为根节点
          if (type !== 'inner' && draggingNode.level === 3 && dropNode.level === 1) {
            return false;
          }
          
          // 允许根节点之间拖拽
          if (draggingNode.level === 1 && dropNode.level === 1 && type !== 'inner') {
            return true;
          }
          
          // 允许子节点之间拖拽
          if (draggingNode.level === 2 && dropNode.level === 2 && type !== 'inner') {
            return true;
          }
          
          // 允许孙节点之间拖拽
          if (draggingNode.level === 3 && dropNode.level === 3 && type !== 'inner') {
            return true;
          }
          
          // 允许将节点拖拽到父节点内部
          if (type === 'inner' && dropNode.level < 3) {
            return true;
          }
          
          return false;
        },
        
        // 检查是否是最后一个根节点
        isLastRootNode(node) {
          return node.level === 1 && this.painspot_navigation_adjust.length === 1;
        },
        
        // 获取所有节点ID
        getAllNodeIds() {
          const ids = [];
          this.painspot_navigation_adjust.forEach(node => {
            ids.push(node.id);
            if (node.children) {
              node.children.forEach(child => {
                ids.push(child.id);
                if (child.children) {
                  child.children.forEach(grandchild => ids.push(grandchild.id));
                }
              });
            }
          });
          return ids;
        },
        
        // 展开/收起所有节点
        expandAll() {
          this.isExpanded = !this.isExpanded;
          this.painspot_navigation_adjust = JSON.parse(JSON.stringify(this.painspot_navigation_adjust));
        },
        
        // 重置树结构
        resetTree() {
          this.$confirm('确定要重置树结构吗？所有数据将丢失', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.painspot_navigation_adjust = [
              { 
                id: 1, 
                label: "默认根节点", 
                children: [
                  { 
                    id: 11, 
                    label: "示例子节点", 
                    children: [
                      { id: 111, label: "示例孙节点1" },
                      { id: 112, label: "示例孙节点2" }
                    ]
                  }
                ] 
              }
            ];
            this.$message.success('树结构已重置');
          }).catch(() => {});
        },
        
        // 高亮显示节点
        highlightNode(nodeId) {
          this.highlightedNode = nodeId;
          
          // 清除之前的定时器
          if (this.highlightTimer) {
            clearTimeout(this.highlightTimer);
          }
          
          // 3秒后移除高亮
          this.highlightTimer = setTimeout(() => {
            this.highlightedNode = null;
          }, 3000);
        },
        
        // 检查节点是否是同级中的第一个
        isFirstNode(node) {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex(item => item.id === node.data.id);
          return index === 0;
        },
        
        // 检查节点是否是同级中的最后一个
        isLastNode(node) {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex(item => item.id === node.data.id);
          return index === children.length - 1;
        },
        
        // 移动节点（上移或下移）
        moveNode(node, data, direction) {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex(item => item.id === data.id);
          
          let newIndex = index;
          
          if (direction === 'up' && index > 0) {
            newIndex = index - 1;
          } else if (direction === 'down' && index < children.length - 1) {
            newIndex = index + 1;
          } else {
            return; // 无法移动
          }
          
          // 交换位置
          const temp = children[newIndex];
          children[newIndex] = children[index];
          children[index] = temp;
          
          // 更新树数据
          this.painspot_navigation_adjust = [...this.painspot_navigation_adjust];
          
          // 高亮显示移动后的节点
          this.highlightNode(data.id);
          
          this.$message.success(`节点已${direction === 'up' ? '上移' : '下移'}`);
        },
        
        // 导出树数据
        exportTreeData() {
          const dataStr = JSON.stringify(this.painspot_navigation_adjust, null, 2);
          const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
          
          const exportFileDefaultName = 'tree-data.json';
          
          const linkElement = document.createElement('a');
          linkElement.setAttribute('href', dataUri);
          linkElement.setAttribute('download', exportFileDefaultName);
          linkElement.click();
          
          this.$message.success('树结构数据已导出');
        },
  },
//   mounted() {
    
//     const editor = this.$refs.myQuillEditor.quill.root;
//     editor.addEventListener('paste', this.handlePasteImage);
    
//     this.$once('hook:beforeDestroy', () => {
//       editor.removeEventListener('paste', this.handlePasteImage);
//     });
    
//     this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imageHandler);
//   },
}
</script>

<style scoped>
::v-deep .el-input__inner {
    height: 28px;
    /* line-height: 28px; */
}
::v-deep .el-input__icon {
    line-height: 28px;
}
::v-deep .el-select .el-input .el-select__caret {
    line-height: 28px;
}
::v-deep .el-table th {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
::v-deep .el-table__row td {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
::v-deep .el-input__icon {
    line-height: 28px;
}
::v-deep .el-cascader {
    line-height: 28px;
}
/* 【重要！】ql-editor 自带overflow，通过调整这里的height去自适应页面高度 */
.ql-editor {
  height: calc(100vh - 80px - 188px) !important;
}
::v-deep .editor-container .ql-editor {
  height: calc(100vh - 80px - 230px) !important;
}
::v-deep .create-container .ql-editor {
  height: calc(100vh - 80px - 250px) !important;
}
/* .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
} */
.tree-container {
    padding: 20px;
    min-height: 450px;
    max-height: 550px;
    overflow-y: auto;
    margin-top: 15px;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding: 8px 0;
    transition: all 0.3s ease;
}
.custom-tree-node:hover {
    background-color: rgba(64, 158, 255, 0.05);
}
.node-content {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 8px;
}
.node-actions {
    display: flex;
    gap: 5px;
    opacity: 0.7;
    transition: opacity 0.3s;
}
.custom-tree-node:hover .node-actions {
    opacity: 1;
}
.node-actions .move-buttons {
    border-right: 1px solid #eee;
    padding-right: 8px;
    margin-right: 5px;
    display: flex;
    gap: 5px;
}
.editing-input {
    width: 200px;
    margin-right: 10px;
}
.empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;
}
.empty-state i {
    font-size: 48px;
    margin-bottom: 15px;
    color: #c0c4cc;
}
.empty-state p {
    margin: 10px 0;
}
.action-buttons {
    display: flex;
    /* gap: 15px; */
    flex-wrap: wrap;
}
.operation-tips {
    background: #f8fafd;
    padding: 25px;
    border-radius: 10px;
    border: 1px dashed #64b5ff;
    font-size: 14px;
    color: #606266;
}
.operation-tips h3 {
    margin-top: 0;
    margin-bottom: 15px;
    color: #409EFF;
    display: flex;
    align-items: center;
}
.operation-tips ul {
    padding-left: 25px;
    margin: 15px 0;
}
.operation-tips li {
    margin-bottom: 10px;
    line-height: 1.6;
}
.highlight {
    background-color: rgba(255, 235, 59, 0.3);
    transition: background-color 2s ease-out;
}
.level-indicator {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: white;
    margin-right: 8px;
}
.level-1 {
    background-color: #409EFF;
}
.level-2 {
    background-color: #67C23A;
}
.level-3 {
    background-color: #E6A23C;
}
@keyframes highlight {
    0% { background-color: rgba(255, 235, 59, 0.5); }
    100% { background-color: transparent; }
}
.highlight-animation {
    animation: highlight 1.5s ease-out;
}
.statistics {
    display: flex;
    gap: 20px;
    margin-top: 15px;
}
.stat-card {
    flex: 1;
    background: linear-gradient(135deg, #f0f7ff 0%, #e6f7ff 100%);
    border-radius: 8px;
    padding: 15px;
    text-align: center;
    border: 1px solid #dcf0ff;
}
.stat-card .number {
    font-size: 24px;
    font-weight: bold;
    color: #409EFF;
    margin: 5px 0;
}
.stat-card .label {
    font-size: 14px;
    color: #606266;
}
</style>

